module.exports = __webpack_public_path__ + "static/img/huodongzixun.31137f60.png";